<div class="banner">
  <div class="row date">
      <div class="col-xs-4 text-left">
          Ficha:<span>{{ fichaTimeline.proposta.id }}</span>
      </div>
      <div class="col-xs-4 text-center">
          Iniciada:<span>{{ fichaTimeline.proposta?.dataHoraEnvio | date: "dd/MM/yyyy" }}</span>|<span>{{ fichaTimeline.proposta?.dataHoraEnvio | date: "HH:mm" }}</span>
      </div>
      <div class="col-xs-4 text-right">
          <div *ngIf="fichaTimeline.proposta!.vendedor" class="user">
              <img class="user-photo" src="https://www.omnifacil.com.br/bs/images/user.png" alt="Foto do usuário" appFallbackImage />
              <span class="name hidden-xs">
                  <span class="text-left">
                      <small>{{fichaTimeline.proposta!.vendedor.nmLoja | titlecase}}</small>
                      {{ fichaTimeline.proposta!.vendedor.nome | titlecase }}
                  </span>
              </span>
          </div>
      </div>
  </div>

  <div class="row client">
      <div class="col-xs-12">
          <span class="title">Cliente</span>
          <div class="content-name">
              <h2>{{ fichaTimeline.proposta?.cliente?.nomeCliente }} </h2>
              <app-sos-inverso [proposta]="fichaTimeline?.proposta" (sosEnviado)="onSosEnviado()" *ngIf="isShowEnviarSOS()"></app-sos-inverso>
          </div>
          <span class="user-id">CPF: {{ fichaTimeline.proposta?.cliente?.cpf | cpf }}</span>
      </div>
  </div>
</div>
